import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const languages = {
  sr: { code: 'sr', name: 'Srpski', shortName: 'SR', flag: 'https://flagcdn.com/w40/rs.png' },
  en: { code: 'en', name: 'English', shortName: 'EN', flag: 'https://flagcdn.com/w40/gb.png' },
  ru: { code: 'ru', name: 'Русский', shortName: 'RU', flag: 'https://flagcdn.com/w40/ru.png' }
};

export const translations = {
  sr: {
    // Navigation
    nav: {
      home: 'Početna',
      about: 'O nama',
      services: 'Usluge',
      gallery: 'Galerija',
      team: 'Tim',
      contact: 'Kontakt'
    },
    // Hero Section
    hero: {
      subtitle: 'Profesionalni Muški Frizerski Salon Zemun | Beograd',
      cta1: 'Pozovite nas',
      cta2: 'Pogledaj usluge',
      scrollDown: 'Scroll Down'
    },
    // About Section
    about: {
      label: 'Upoznajte nas',
      title: 'Muški Frizerski Salon u Zemunu',
      subtitle: 'Profesionalni Muški Frizerski Salon sa Tradicijom od 21 Godinu Iskustva',
      p1: 'Studio 149 je profesionalni muški frizerski salon u srcu Zemuna, na adresi Cara Dušana 153. Već godinama pružamo vrhunske usluge šišanja, sređivanja brade i stylinga muške kose, uz individualan pristup svakom klijentu.',
      p2: 'Naš barbershop nudi širok spektar usluga – od klasičnog muškog šišanja i modernih fade frizura (high fade, mid fade, low fade), do preciznog uređivanja brade i hot towel brijanja. Bilo da tražite trendi izgled ili tradicionalni stil, naši iskusni barber majstori će vam pomoći da pronađete savršenu frizuru.',
      p3: 'Koristimo samo kvalitetne profesionalne preparate i najnovije tehnike šišanja. U prijatnom ambijentu našeg salona možete se opustiti dok naš tim brine o vašem izgledu. Svaki klijent je poseban, a naša misija je da izađete iz salona zadovoljni i sa osmehom.',
      p4: 'Pozicionirani u centralnom delu Zemuna, lako smo dostupni kako stanovnicima Gornjeg i Donjeg grada, tako i posetiocima iz cele Beogradske regije. Radimo od ponedeljka do petka od 08 do 20h, i subotom od 08 do 16h. Za brzu uslugu bez čekanja, pozovite nas i zakažite termin!'
    },
    // Services Section
    services: {
      label: 'Šta nudimo',
      title: 'Šišanje i Usluge Našeg Frizerskog Salona',
      subtitle: '',
      info: 'Za detaljne informacije o cenama, kontaktirajte nas',
      items: [
        { name: 'Muško šišanje', description: 'Klasično i moderno muško šišanje prilagođeno vašem stilu', price: 'Po upitu' },
        { name: 'Pranje kose', description: 'Profesionalno pranje kose uz kvalitetne preparate', price: 'Po upitu' },
        { name: 'Sređivanje brade', description: 'Precizno oblikovanje i trimovanje brade', price: 'Po upitu' },
        { name: 'Šišanje + Brada', description: 'Kompletna usluga šišanja i sređivanja brade', price: 'Po upitu' },
        { name: 'Dečije šišanje', description: 'Prijatno iskustvo šišanja za najmlađe', price: 'Po upitu' },
        { name: 'Fade šišanje', description: 'Trendi fade i savremene muške frizure', price: 'Po upitu' }
      ]
    },
    // Gallery Section
    gallery: {
      label: '',
      title: 'Naša Galerija',
      subtitle: '',
      view: 'Pogledaj'
    },
    // Team Section
    team: {
      label: 'Naš tim',
      title: 'Iskusni Frizerski Majstori',
      subtitle: 'Profesionalni frizeri za muškarce u Zemunu',
      members: [
        { name: 'Ana', position: 'Glavni Frizer', isReal: true },
        { name: 'Đurđa', position: 'Glavni Frizer', isReal: true },
        { name: 'Nikola Đorđević', position: 'Barber Stilista', isReal: false },
        { name: 'Aleksandar Ilić', position: 'Junior Barber', isReal: false }
      ]
    },
    // Contact Section
    contact: {
      label: 'Kontaktirajte nas',
      title: 'Lokacija i Radno Vreme',
      subtitle: 'Cara Dušana 153, Zemun - Zakazivanje termina',
      location: 'Lokacija',
      phone: 'Telefon',
      hours: 'Radno vreme',
      weekdays: 'Pon - Pet: 08:00 - 20:00',
      saturday: 'Subota: 08:00 - 16:00',
      ctaText: '',
      ctaButton: 'Pozovite nas',
      mapLink: 'Otvori u Google Maps'
    },
    // Footer
    footer: {
      description: 'Profesionalni muški frizerski salon u srcu Zemuna. Kvalitetno šišanje i prijatna atmosfera.',
      quickLinks: 'Brzi linkovi',
      contactInfo: 'Kontakt info',
      followUs: 'Pratite nas',
      rights: 'Sva prava zadržana. Website napravili Savatije Grujović i Miloš Stanojević.'
    },
    // Parallax Slogans
    slogans: [
      'Vaš stil, naša strast',
      'Tradicija i moderni pristup',
      'Gde svaki detalj ima značaj'
    ]
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      gallery: 'Gallery',
      team: 'Team',
      contact: 'Contact'
    },
    // Hero Section
    hero: {
      subtitle: 'Professional Men\'s Hairdresser Salon Zemun | Belgrade',
      cta1: 'Call Us',
      cta2: 'View Services',
      scrollDown: 'Scroll Down'
    },
    // About Section
    about: {
      label: 'Get to Know Us',
      title: 'Men\'s Hairdresser Salon in Zemun',
      subtitle: 'Professional Men\'s Hairdresser Salon with 21 Years of Tradition',
      p1: 'Studio 149 is a professional men\'s hairdresser salon in the heart of Zemun, located at Cara Dušana 153. For years, we have been providing top-quality haircuts, beard grooming, and men\'s hair styling services, with an individual approach to each client.',
      p2: 'Our salon offers a wide range of services – from classic men\'s haircuts and modern fade hairstyles (high fade, mid fade, low fade), to precise beard trimming and hot towel shaving. Whether you\'re looking for a trendy look or traditional style, our experienced hairdressers will help you find the perfect haircut.',
      p3: 'We use only quality professional products and the latest cutting techniques. In the pleasant atmosphere of our salon, you can relax while our team takes care of your appearance. Every client is special, and our mission is for you to leave the salon satisfied and with a smile.',
      p4: 'Located in the central part of Zemun, we are easily accessible to residents of Upper and Lower Town, as well as visitors from the entire Belgrade region. We work Monday to Friday from 08:00 to 20:00, and Saturday from 08:00 to 16:00. For quick service without waiting, call us and book an appointment!'
    },
    // Services Section
    services: {
      label: 'What We Offer',
      title: 'Haircuts and Services of Our Hairdresser Salon',
      subtitle: '',
      info: 'For detailed pricing information, contact us',
      items: [
        { name: 'Men\'s Haircut', description: 'Classic and modern men\'s haircut tailored to your style', price: 'On request' },
        { name: 'Hair Wash', description: 'Professional hair wash with quality products', price: 'On request' },
        { name: 'Beard Trim', description: 'Precise shaping and trimming of the beard', price: 'On request' },
        { name: 'Haircut + Beard', description: 'Complete haircut and beard grooming service', price: 'On request' },
        { name: 'Kids Haircut', description: 'Pleasant haircut experience for the youngest', price: 'On request' },
        { name: 'Fade Haircut', description: 'Trendy fade and contemporary men\'s hairstyles', price: 'On request' }
      ]
    },
    // Gallery Section
    gallery: {
      label: '',
      title: 'Our Gallery',
      subtitle: '',
      view: 'View'
    },
    // Team Section
    team: {
      label: 'Our Team',
      title: 'Experienced Hairdresser Masters',
      subtitle: 'Professional hairdressers for men in Zemun',
      members: [
        { name: 'Ana', position: 'Head Hairdresser', isReal: true },
        { name: 'Đurđa', position: 'Head Hairdresser', isReal: true },
        { name: 'Nikola Đorđević', position: 'Hairdresser Stylist', isReal: false },
        { name: 'Aleksandar Ilić', position: 'Junior Hairdresser', isReal: false }
      ]
    },
    // Contact Section
    contact: {
      label: 'Contact Us',
      title: 'Location and Working Hours',
      subtitle: 'Cara Dušana 153, Zemun - Book an Appointment',
      location: 'Location',
      phone: 'Phone',
      hours: 'Working Hours',
      weekdays: 'Mon - Fri: 08:00 - 20:00',
      saturday: 'Saturday: 08:00 - 16:00',
      ctaText: '',
      ctaButton: 'Call Us',
      mapLink: 'Open in Google Maps'
    },
    // Footer
    footer: {
      description: 'Professional men\'s hairdresser salon in the heart of Zemun. Quality haircuts and pleasant atmosphere.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Info',
      followUs: 'Follow Us',
      rights: 'All rights reserved. Website by Savatije Grujović i Miloš Stanojević.'
    },
    // Parallax Slogans
    slogans: [
      'Your style, our passion',
      'Tradition and modern approach',
      'Where every detail matters'
    ]
  },
  ru: {
    // Navigation
    nav: {
      home: 'Главная',
      about: 'О нас',
      services: 'Услуги',
      gallery: 'Галерея',
      team: 'Команда',
      contact: 'Контакт'
    },
    // Hero Section
    hero: {
      subtitle: 'Профессиональная мужская парикмахерская Земун | Белград',
      cta1: 'Позвоните нам',
      cta2: 'Посмотреть услуги',
      scrollDown: 'Прокрутить вниз'
    },
    // About Section
    about: {
      label: 'Познакомьтесь с нами',
      title: 'Мужская парикмахерская в Земуне',
      subtitle: 'Профессиональная мужская парикмахерская с 21-летней традицией',
      p1: 'Studio 149 — профессиональная мужская парикмахерская в самом сердце Земуна, по адресу Цара Душана 153. Уже много лет мы предоставляем услуги высококачественной стрижки, ухода за бородой и укладки мужских волос с индивидуальным подходом к каждому клиенту.',
      p2: 'Наш барбершоп предлагает широкий спектр услуг — от классической мужской стрижки и современных фейд-стрижек (high fade, mid fade, low fade) до точного оформления бороды и бритья горячим полотенцем. Ищете ли вы модный образ или традиционный стиль, наши опытные барберы помогут вам найти идеальную стрижку.',
      p3: 'Мы используем только качественные профессиональные средства и новейшие техники стрижки. В приятной атмосфере нашего салона вы можете расслабиться, пока наша команда заботится о вашем внешнем виде. Каждый клиент особенный, и наша миссия — чтобы вы ушли из салона довольными и с улыбкой.',
      p4: 'Расположенные в центральной части Земуна, мы легко доступны как для жителей Верхнего и Нижнего города, так и для посетителей со всего Белградского региона. Работаем с понедельника по пятницу с 08:00 до 20:00 и в субботу с 08:00 до 16:00. Для быстрого обслуживания без ожидания позвоните нам и запишитесь!'
    },
    // Services Section
    services: {
      label: 'Что мы предлагаем',
      title: 'Стрижки и услуги нашей парикмахерской',
      subtitle: '',
      info: 'Для получения подробной информации о ценах свяжитесь с нами',
      items: [
        { name: 'Мужская стрижка', description: 'Классическая и современная мужская стрижка под ваш стиль', price: 'По запросу' },
        { name: 'Мытье волос', description: 'Профессиональное мытье волос качественными средствами', price: 'По запросу' },
        { name: 'Оформление бороды', description: 'Точное моделирование и подстригание бороды', price: 'По запросу' },
        { name: 'Стрижка + Борода', description: 'Полная услуга стрижки и ухода за бородой', price: 'По запросу' },
        { name: 'Детская стрижка', description: 'Приятный опыт стрижки для самых маленьких', price: 'По запросу' },
        { name: 'Фейд-стрижка', description: 'Модные фейд и современные мужские прически', price: 'По запросу' }
      ]
    },
    // Gallery Section
    gallery: {
      label: '',
      title: 'Наша галерея',
      subtitle: '',
      view: 'Смотреть'
    },
    // Team Section
    team: {
      label: 'Наша команда',
      title: 'Опытные барбер-мастера',
      subtitle: 'Профессиональные парикмахеры для мужчин в Земуне',
      members: [
        { name: 'Ана', position: 'Главный парикмахер', isReal: true },
        { name: 'Джурджа', position: 'Главный парикмахер', isReal: true },
        { name: 'Никола Джорджевич', position: 'Барбер-стилист', isReal: false },
        { name: 'Александар Илич', position: 'Младший барбер', isReal: false }
      ]
    },
    // Contact Section
    contact: {
      label: 'Свяжитесь с нами',
      title: 'Местоположение и время работы',
      subtitle: 'Цара Душана 153, Земун - Запись на прием',
      location: 'Местоположение',
      phone: 'Телефон',
      hours: 'Время работы',
      weekdays: 'Пн - Пт: 08:00 - 20:00',
      saturday: 'Суббота: 08:00 - 16:00',
      ctaText: '',
      ctaButton: 'Позвоните нам',
      mapLink: 'Открыть в Google Maps'
    },
    // Footer
    footer: {
      description: 'Профессиональная мужская парикмахерская в самом сердце Земуна. Качественные стрижки и приятная атмосфера.',
      quickLinks: 'Быстрые ссылки',
      contactInfo: 'Контактная информация',
      followUs: 'Подписывайтесь',
      rights: 'Все права защищены. Сайт разработан: Саватие Груйович и Милош Станоевич.'
    },
    // Parallax Slogans
    slogans: [
      'Ваш стиль, наша страсть',
      'Традиции и современный подход',
      'Где каждая деталь имеет значение'
    ]
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved language preference
    const saved = localStorage.getItem('studio149-language');
    return saved || 'sr';
  });

  useEffect(() => {
    localStorage.setItem('studio149-language', language);
    // Update html lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];
  
  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
